import {DocumentTemplateSolutionService} from '../../../services/documentTemplateSolutionService';
import {createEntityThunks} from '../../../utils/createEntityThunks';
import {DocumentTemplateSolution} from '../../../types/documentTemplateSolution';

const DocumentTemplateSolutionFactory = (data: any) => new DocumentTemplateSolution(data);

export const DocumentTemplateSolutionThunks = createEntityThunks<DocumentTemplateSolution>(
  'documentTemplateSolution',
  DocumentTemplateSolutionService,
  {activate: false, deactivate: false},
  DocumentTemplateSolutionFactory,
);
